import { c as _c } from "react/compiler-runtime";
import { isEmptyValue } from '@bridge/utils';
import { Body } from '../typography';
import { EmptyValue } from './EmptyValue';
import { FlexContainer } from './FlexContainer';
import InfoTooltip from './InfoTooltip';
import clsxm from '../utils/style';
export interface InfoRowProps {
  className?: string;
  label: string;
  value: React.ReactNode;
  valueClassName?: string;
  /** Optional tooltip shown via an info icon next to the label. */
  labelTooltip?: React.ReactNode;
  variant?: 'stacked' | 'inline';
  /** When true, hides values that are empty per isEmptyValue: null, undefined, empty string, empty array or object. */
  hideWhenEmpty?: boolean;
}
export function InfoRow(t0) {
  const $ = _c(25);
  const {
    className,
    label,
    value,
    valueClassName,
    labelTooltip,
    variant: t1,
    hideWhenEmpty
  } = t0;
  const variant = t1 === undefined ? "stacked" : t1;
  if (hideWhenEmpty && isEmptyValue(value)) {
    return null;
  }
  let t2;
  if ($[0] !== value || $[1] !== valueClassName) {
    t2 = isEmptyValue(value) ? <EmptyValue /> : <Body className={valueClassName} size="sm">{value}</Body>;
    $[0] = value;
    $[1] = valueClassName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const displayValue = t2;
  if (variant === "inline") {
    let t3;
    if ($[3] !== className) {
      t3 = clsxm("py-2.5 w-full", className);
      $[3] = className;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== labelTooltip) {
      t4 = labelTooltip != null && <InfoTooltip size="xs">{labelTooltip}</InfoTooltip>;
      $[5] = labelTooltip;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== label || $[8] !== t4) {
      t5 = <Body className="flex items-center gap-1 text-content-secondary" size="sm">{label}{t4}</Body>;
      $[7] = label;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== displayValue || $[11] !== t3 || $[12] !== t5) {
      t6 = <FlexContainer className={t3} items="center" justify="between">{t5}{displayValue}</FlexContainer>;
      $[10] = displayValue;
      $[11] = t3;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t3;
  if ($[14] !== className) {
    t3 = clsxm("flex flex-col gap-0.5", className);
    $[14] = className;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== labelTooltip) {
    t4 = labelTooltip != null && <InfoTooltip size="xs">{labelTooltip}</InfoTooltip>;
    $[16] = labelTooltip;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== label || $[19] !== t4) {
    t5 = <Body className="flex items-center gap-1 text-content-secondary" size="xs">{label}{t4}</Body>;
    $[18] = label;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== displayValue || $[22] !== t3 || $[23] !== t5) {
    t6 = <div className={t3}>{t5}{displayValue}</div>;
    $[21] = displayValue;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}